import { unsafeCardId } from '@wonders/platform-core';
export const DEMO_LANE_DECK = [
    { id: unsafeCardId('dl-acolyte'), name: 'Acolyte', cost: 1, power: 1 },
    { id: unsafeCardId('dl-scout'), name: 'Scout', cost: 1, power: 2 },
    { id: unsafeCardId('dl-soldier'), name: 'Soldier', cost: 2, power: 2 },
    { id: unsafeCardId('dl-knight'), name: 'Knight', cost: 3, power: 3 },
    { id: unsafeCardId('dl-ranger'), name: 'Ranger', cost: 2, power: 3 },
    { id: unsafeCardId('dl-mage'), name: 'Mage', cost: 3, power: 4 },
    { id: unsafeCardId('dl-veteran'), name: 'Veteran', cost: 4, power: 4 },
    { id: unsafeCardId('dl-captain'), name: 'Captain', cost: 4, power: 5 },
    { id: unsafeCardId('dl-warlord'), name: 'Warlord', cost: 5, power: 6 },
    { id: unsafeCardId('dl-paladin'), name: 'Paladin', cost: 3, power: 3 },
    { id: unsafeCardId('dl-druid'), name: 'Druid', cost: 2, power: 2 },
    { id: unsafeCardId('dl-archer'), name: 'Archer', cost: 2, power: 3 },
];
//# sourceMappingURL=cards.js.map